import Navbar from './sections/Navbar'
import Hero from './sections/Hero'
import Vision from './sections/Vision'
import HowItWorks from './sections/HowItWorks'
import Partners from './sections/Partners'
import CTA from './sections/CTA'
import Footer from './sections/Footer'

export default function App() {
  return (
    <div className="min-h-screen bg-base-100 text-base-content">
      <Navbar />
      <main>
        <Hero />
        <Vision />
        <HowItWorks />
        <Partners />
        <CTA />
      </main>
      <Footer />
    </div>
  )
}
